import Vue from 'vue';

import Vuetify, {
  VAlert,
  VApp,
  VBtn,
  VCard,
  VCardText,
  VContainer,
  VDialog,
  VFabTransition,
  VFlex,
  VHover,
  VIcon,
  VImg,
  VLayout,
  VListTile,
  VListTileAvatar,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
  VProgressLinear,
  VTooltip,
  VDataTable,
  VCardActions,
  VCardTitle,
  VExpansionPanel,
  VExpansionPanelContent,
  VCarousel,
  VCarouselItem,
  VRating,
  VDivider,
  VList,
  VTextField,
  VBreadcrumbs,
  VSubheader,
  VAutocomplete,
} from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import filters from '@/filters';

Vue.use(Vuetify, {
  iconfont: 'md',
  components: {
    VApp,
    VBtn,
    VCard,
    VCardText,
    VContainer,
    VFlex,
    VHover,
    VIcon,
    VLayout,
    VTooltip,
    VAlert,
    VFabTransition,
    VProgressLinear,
    VDialog,
    VListTile,
    VListTileSubTitle,
    VListTileContent,
    VListTileTitle,
    VImg,
    VListTileAvatar,
    VDataTable,
    VCardActions,
    VCardTitle,
    VExpansionPanel,
    VExpansionPanelContent,
    VCarousel,
    VCarouselItem,
    VRating,
    VDivider,
    VList,
    VTextField,
    VBreadcrumbs,
    VSubheader,
    VAutocomplete,
  },
});

Vue.filter('formatPercent', filters.formatPercent);
Vue.filter('formatNumber', filters.formatNumber);
Vue.filter('formatRank', filters.formatRank);
Vue.filter('formatDate', filters.formatDate);
